import { render, staticRenderFns } from "./ProviderModal.vue?vue&type=template&id=37139f44&scoped=true"
import script from "./ProviderModal.vue?vue&type=script&lang=js"
export * from "./ProviderModal.vue?vue&type=script&lang=js"
import style0 from "./ProviderModal.vue?vue&type=style&index=0&id=37139f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37139f44",
  null
  
)

export default component.exports